import Cookies from "js-cookie";

// Shared by the Student/College/Author dashboard pages — previously each page
// defined its own copy of this, and the copies had quietly drifted: the
// roles-based fallback only ever checked for the one role that page cared
// about (e.g. the Author dashboard's copy never recognized ROLE_ADMIN or
// ROLE_COLLEGE), so a user whose "accountType" cookie was missing could be
// mis-bucketed as "student" depending on which dashboard happened to run the
// check. This version checks every role, matching the logic already used in
// Header.js/App.js.
export function getAccountType() {
  const fromCookie = Cookies.get("accountType");
  if (fromCookie) return fromCookie;

  try {
    const roles = JSON.parse(Cookies.get("roles") || "[]");
    if (roles.includes("ROLE_ADMIN")) return "admin";
    if (roles.includes("ROLE_COLLEGE")) return "college";
    if (roles.includes("ROLE_AUTHOR")) return "author";
    return "student";
  } catch {
    return "student";
  }
}
